/* eslint-disable no-unused-vars */
export enum Notification {
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  DEFAULT = 'default'
}
